import type { QuickstartTheme } from '../quickstart/types/theme';

/**
 * Playcast brand colors (from tailwind theme-midnight config)
 */
const PLAYCAST_COLORS = {
  teal: '#63D2DA',
  tealBright: '#5DAFCD',
  midnightBlue: '#2D618C',
  dark: '#1B4366',
  darker: '#122741',
  darkest: '#0F1727',
  white: '#DEFFFF',
} as const;

export const BEACON_THEME: QuickstartTheme = {
  slug: 'beacon',
  gameName: 'Playcast',
  studioName: 'Playcast',
  gameLogo: '/icon.png',
  gameLogoHeight: 64,
  primaryColor: PLAYCAST_COLORS.teal,
  secondaryColor: PLAYCAST_COLORS.tealBright,
  modalBackgroundColor: PLAYCAST_COLORS.darkest,
  modalBackgroundOpacity: 0.95,
  spinnerColor: PLAYCAST_COLORS.teal,
  badgeOverrideTextColor: '#FFFFFF',
  releaseDateTextColor: '#FFFFFF',
  storePlatform: 'Playcast',
  afkTimeoutSeconds: 0,
  adTimerSeconds: 0,
  seamlessMode: false,
};
